import React, { useContext } from "react";
import LoadingOverlay from "react-loading-overlay";
import { BeatLoader } from "react-spinners";
import { AppContext } from "../../domain/App/AppContext";

export default Component => props => {
  const inProgress = useContext(AppContext).promiseInProgress;

  return (
    <div>
      <LoadingOverlay
        active={inProgress}
        spinner={<BeatLoader size={15} margin={10} color={"#1890ff"} />}
      >
        <Component {...props} />
      </LoadingOverlay>
    </div>
  );
};
